import { PropsWithChildren } from "react";

import Button, { buttonTheme } from "@components/button/button";
import { getTopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";

const ModalTitle = ({
  onClose,
  children,
  className,
}: PropsWithChildren<{
  onClose?: () => void;
  className?: string;
}>) => (
  <div
    className={classNames("flex items-center justify-between gap-2", className)}
  >
    <h3 className="flex-1 text-lg leading-6 font-medium text-gray-900">
      {children}
    </h3>
    {onClose && (
      <Button
        icon={getTopicflowIcon("close")}
        onClick={onClose}
        theme={buttonTheme.iconGray}
        aria-label="Close modal button"
      />
    )}
  </div>
);

export default ModalTitle;
